import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
(
    <Suspense fallback={<SuspenseLoader />}>
        <Component {...props} />
    </Suspense>
);

// Dashboards

const DashboardOperator = Loader(
    lazy(() => import('src/content/operator/Dashboard'))
);

const Events = Loader(lazy(() => import('src/content/operator/Event')));
const Assigments = Loader(lazy(() => import('src/content/operator/Assigment')));
const Report = Loader(lazy(() => import('src/content/operator/Reports')));
const Notification = Loader(lazy(() => import('src/content/operator/Notification')));

const operatorRoutes = [
    {
        path: '/',
        element: <Navigate to="dashboard" replace />
    },
    {
        path: 'dashboard',
        element: <DashboardOperator />
    },
    {
        path: 'events',
        element: <Events />
    },
    {
        path: 'reports',
        element: <Report />
    },
    {
        path: 'assignments',
        element: <Assigments />
    },
    {
        path: 'notifications',
        element: <Notification />
    },
];

export default operatorRoutes;
